import { DataGrid } from "@mui/x-data-grid";
import { useLoaderData, useNavigation } from "react-router-dom";
import useDataGridPaging from "../../app/useDataGridPaging";
import { PagedResponse } from "../../types/Result";
import { SystemLog } from "../log/type";
import { chatColumns } from "./columns";

export default function ChatDataGrid() {
  const data = useLoaderData() as PagedResponse<SystemLog>;
  const navigation = useNavigation();
  const {
    handlePaginationModelChange,
    handleSortModelChange,
    paginationModel,
    sortModel,
    handleFilterChange,
    filterModel,
  } = useDataGridPaging(data);
  return (
    <>
      <DataGrid
        autoHeight
        sx={{ width: "100%" }}
        rows={data.data!}
        getRowId={(row) => row.id}
        columns={chatColumns}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        paginationModel={paginationModel}
        loading={navigation.state === "loading"}
        rowCount={data.totalCount}
        paginationMode="server"
        sortingMode="server"
        filterMode="server"
        filterModel={filterModel}
        pageSizeOptions={[10, 20, 50, 100]}
        disableColumnResize
        onSortModelChange={handleSortModelChange}
        onPaginationModelChange={handlePaginationModelChange}
        sortModel={sortModel}
        onFilterModelChange={handleFilterChange}
        density="compact"
        slotProps={{
          filterPanel: {
            filterFormProps: {
              logicOperatorInputProps: {
                variant: "outlined",
                size: "small",
              },
              columnInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              operatorInputProps: {
                variant: "outlined",
                size: "small",
                sx: { mt: "auto" },
              },
              valueInputProps: {
                InputComponentProps: {
                  variant: "outlined",
                  size: "small",
                },
              },
            },
          },
        }}
      />
    </>
  );
}
